
import { Fragment } from "react/jsx-runtime";
import {
  ReportContainer,
  Section,
  SectionLight,
  SectionDark,
  HeaderText,
  SectionHeading,
  HeaderTextDark,
  LineText,
  LineTextInd,
  ReportDetail,
  LineKey,
  LineVal,
} from "./qapi_template.styles";

const ReportsSectionContent = ({
  heading,
  subHeadings,
  isSectionEmpty,
  shouldHeaderRender,
}: {
  heading: string;
  subHeadings: { [x: string]: any[] };
  isSectionEmpty: boolean;
  shouldHeaderRender: boolean;
}) => {
  if (shouldHeaderRender && isSectionEmpty) {
    return <div>No {heading} reported</div>;
  }

   const renderFieldValue = (value: any) => {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value);
    }
    return value || '-';
  };

   return (
      <Section>            
      {Object.keys(subHeadings as any).map((subHeading, index) => {
        const fields = Object.values(subHeadings as any)[index];
        const isFieldsEmpty = (fields as any).length === 0;
        const shouldSubHeadingRender =
          subHeading !== "Default" && subHeading !== heading && !isFieldsEmpty;
        return (
          <Section key={`${subHeading}-${index}`}>
            {shouldSubHeadingRender && (
              <SectionHeading>{subHeading}</SectionHeading>
            )}
            {!isFieldsEmpty && (
              (fields as any[]).map((field: any, fieldIndex: number) => (
                <LineTextInd key={`${field.fieldName}-${fieldIndex}`}><LineKey>{field.fieldLabel}</LineKey><LineVal>{renderFieldValue(field.fieldValue)}</LineVal></LineTextInd>
              ))
            )}
          </Section>
        );
      })}
       </Section>
   );
};

export default ReportsSectionContent;